import gql from 'graphql-tag';

export default gql`
  fragment bankFragment on BankType {
    id
    userId
    name
    branch
    accountType
    accountTypeText
    accountNumber
    accountName
  }
`;
